export interface QueryOptions {
  enabled?: boolean
  skip?: boolean
}

export const resolveEnabled = (options?: QueryOptions) => {
  if (typeof options?.enabled === "boolean") {
    return options.enabled
  }
  return options?.skip ? false : true
}
